import { Modal } from 'antd';
import classNames from 'classnames';
import CustomButton from '../customButton';
import type { ConfirmModalProps } from './types';
import './confirmModal.scss';

/**
 * Default no-op handler standing in for an absent optional callback prop of the confirm modal. Accepts no arguments and performs no work.
 *
 * @returns Nothing.
 */
const NOOP = () => {};

const ConfirmModal = ({
  className = undefined,
  isOpen,
  centered = true,
  width,
  destroyOnClose = false,
  zIndex,
  title,
  customContent = undefined,
  question = null,
  hasNoButton = false,
  leftButtonName = undefined,
  leftButtonClassName = undefined,
  buttonLeftStyle = 'neutral',
  isSaving = false,
  onClickLeftButton = NOOP,
  rightButtonClassName = undefined,
  buttonRightStyle = undefined,
  buttonRightType = undefined,
  onClickRightButton,
  disabledRightButton = false,
  rightButtonName,
}: ConfirmModalProps) => (
  <Modal
    className={classNames('confirm-modal', className)}
    open={isOpen}
    centered={centered}
    footer={null}
    width={width || 400}
    closeIcon={null}
    destroyOnClose={destroyOnClose}
    zIndex={zIndex || 1000}
    title={title || undefined}
    classNames={{ header: 'header' }}
  >
    <div className="custom-modal-content">
      {customContent || <div className="content">{question}</div>}
    </div>
    {hasNoButton ? null : (
      <div className="footer">
        {leftButtonName ? (
          <CustomButton
            id="left-btn"
            className={leftButtonClassName}
            type="outline"
            style={buttonLeftStyle as any}
            disabled={isSaving}
            onClick={onClickLeftButton}
          >
            {leftButtonName}
          </CustomButton>
        ) : (
          <div />
        )}
        <CustomButton
          id="right-id-btn"
          className={rightButtonClassName}
          styles={{ minWidth: 80 }}
          style={buttonRightStyle as any}
          type={buttonRightType as any}
          loading={isSaving}
          onClick={onClickRightButton}
          disabled={disabledRightButton}
        >
          {rightButtonName}
        </CustomButton>
      </div>
    )}
  </Modal>
);

export default ConfirmModal;
